import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AmChartsModule } from '@amcharts/amcharts3-angular';
import { PieComponent } from './pie/pie.component';
import { ColumnComponent } from './column/column.component';

require('amcharts3/amcharts/amcharts.js');
require('amcharts3/amcharts/gauge.js');
require('amcharts3/amcharts/serial.js');
require('amcharts3/amcharts/pie.js');
require('amcharts3/amcharts/xy.js');
require('amcharts3/amcharts/plugins/animate/animate.min.js');
require('amcharts3/amcharts/themes/light.js');

@NgModule({
  imports: [
    CommonModule,
    AmChartsModule
  ],
  declarations: [
    ColumnComponent,
    PieComponent
  ],
  exports: [
    ColumnComponent,
    PieComponent
  ]
})
export class ChartsModule {
}
